<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-assignment-view">
    <vs-alert v-if="errorOccurred" color="danger" title="Assignment Not Found">
      <span>Assignment record with id: not found. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'admin-list-examedge-assignment' }" class="text-inherit underline">All Assignments</router-link>
      </span>
    </vs-alert>

    <div v-if="assignmentData" id="assignment-data">
      <!--- TOP SET BANNER START --->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <div
            class="rounded-lg w-full main-border"
            style="
              background-image: url(https://connect-cdn.intellectualpoint.com/assets/images/backgrounds/global-banner.png);
              background-size: cover;
            "
          >
            <div class="knowledge-base-jumbotron-content rounded-lg lg:p-8 sm:p-8 p-8">
              <div class="flex justify-between items-center">
                <div>
                  <h1 class="text-white w-full" style="font-size: 3.5rem">{{ assignmentData.name }}</h1>
                </div>
                <img class="rounded" :src="assignmentData.thumbnail" v-if="assignmentData.thumbnail" width="150px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- TOP SET BANNER END --->

      <!--- SET ACTION BAR START --->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col grid grid-cols-3 gap-8 w-full">
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="$router.push(`/a/examedge/assignments?bank=${assignmentData.bank}`)"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-warning), 0.4), rgba(var(--vs-warning), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Back To<br />Bank Assignments</h2>
            </div>
          </vx-card>
          <vx-card
            class="p-6 cursor-pointer"
            @click="$router.push(`/a/examedge/assignments/${assignmentData.id}/edit`)"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="EditIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Edit<br />Assignment</h2>
            </div>
          </vx-card>

          <!--- <vx-card class="p-6 cursor-pointer text-white" @click="$router.push(`/a/examedge/assignments/${assignmentData.id}/builder`)"
                   :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`">
            <div class="flex items-center justify-center">
              <feather-icon icon="ZapIcon" svgClasses="h-16 w-16"/>
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Assignment<br>Builder</h2>
            </div>
          </vx-card> -->
          <vx-card
            class="p-6 cursor-pointer text-white"
            @click="confirmDeleteAssignment"
            :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`"
          >
            <div class="flex items-center justify-center">
              <feather-icon icon="TrashIcon" svgClasses="h-16 w-16" />
            </div>
            <div class="flex items-center justify-center">
              <h2 class="text-center mt-4 text-white">Archive<br />Assignment</h2>
            </div>
          </vx-card>
        </div>
      </div>
      <!--- SET ACTION BAR END --->

      <!--- SET SHOW INFORMATION START--->
      <div class="vx-row mb-6 match-height">
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Id</h3>
            <h3 class="font-light">{{ assignmentData.id }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Status</h3>
            <h3 class="capitalize font-light">{{ assignmentData.status }}</h3>
          </vx-card>
        </div>
        <div class="vx-col w-1/3">
          <vx-card class="w-full flex items-center">
            <h3 class="font-bold">Assignment Details</h3>
            <h3 class="capitalize font-light">
              {{ assignmentData.mode }} Mode With Range {{ assignmentData.rangeStart }} - {{ assignmentData.rangeEnd }} And
              {{ assignmentData.questions }} Questions
            </h3>
          </vx-card>
        </div>
      </div>
      <!--- SET SHOW INFORMATION END--->
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import ListQuestions from '../../questions/question-list/ListQuestions';

export default {
  data() {
    return {
      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676',

      assignmentData: null,

      errorOccurred: false,
    };
  },
  components: {
    Prism,
    vSelect,
    ListQuestions,
  },
  methods: {
    fetchAssignmentDetails(id) {
      this.$http
        .get(`examedge/assignment/${id}`)
        .then((response) => {
          if (response.status === 200) {
            this.assignmentData = response.data;
          }
        })
        .catch((error) => {
          this.errorOccurred = true;
        });
    },
    confirmDeleteAssignment() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this assignment.',
        accept: this.deleteAssignment,
        acceptText: 'Archive',
      });
    },
    deleteAssignment() {
      this.$vs.loading();

      this.$http
        .delete(`examedge/assignment/${this.$route.params.assignmentId}`)
        .then((response) => {
          this.$vs.loading.close();

          if (response.status === 200) {
            this.$router.push('/a/examedge/assignments');

            return this.$vs.notify({
              color: 'success',
              title: 'Assignment Archived',
              text: 'You have successfully archived this assignment',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right',
            });
          }
        })
        .catch((exception) => {
          this.$vs.loading.close();
          this.handleError(exception, 'Failed to archive assignment');
        });
    },
    handleError(exception, title, text) {
      let error = 'An unknown error occurred while doing this action';
      if (exception.response) {
        error = exception.response.data.message;
      }
      if (text) {
        error = text;
      }
      return this.$vs.notify({
        title,
        text: error,
        color: 'danger',
        position: 'top-right',
      });
    },
  },
  created() {
    this.fetchAssignmentDetails(this.$route.params.assignmentId);
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-assignment-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }

  @media (min-width: 1200px) and (max-width: 1700px) {
    .image-assignment {
      display: none;
    }
    .assignment-col {
      width: 0 !important;
      min-height: 2.05vh;
    }
    .welcome-col {
      width: 100% !important;
    }
  }
}
</style>
